import "./dashboard-layout.css";
import { useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import useLangStore from "@/hooks/useLangStore";
import useAuthStore from "@/hooks/useAuthStore";
import useDashboardStore from "@/hooks/useDashboardStore";
import SideBar from "@/UI/components/SideBar";
import AppBar from "@/UI/components/AppBar";

export default function DashboardLayoutRoute() {
    const { lang } = useLangStore();
    const { token } = useAuthStore();
    const { storeId } = useDashboardStore();
    const [sidebarOpen, setSidebarOpen] = useState(false);

    if (!lang) return <Navigate to="/choose-lang" replace />;
    if (!token) return <Navigate to="/login" replace />;
    if (!storeId) return <Navigate to="/select-store" replace />;

    return (
        <div className="dashboard-root">
            {sidebarOpen && <div className="sidebar-backdrop" onClick={() => setSidebarOpen(false)} />}
            <SideBar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
            <div className="dashboard-main">
                <AppBar onMenuClick={() => setSidebarOpen(true)} />
                <main className="dashboard-content">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}
